// Query Keys
export const QUERY_KEY_COMMENT_TEMPLATE_LIST = 'comment-template-list'

// API Constants
export const TEMPLATES_BASE_URL = '/document/v1/templates'
export const TEMPLATE_LIST_PAGINATION_LIMIT = 100
export const TEMPLATE_DEFAULT_SORT = '+name'

// UI Constants
export const CONTENT_PREVIEW_LENGTH = 150
export const SEARCH_DEBOUNCE_DELAY = 300
